<template>
  <div class="tm-scope tm-dash-shell">
    <div class="tm-dash-shell__inner">
      <h1 class="tm-page-title">Your standardization</h1>

      <div class="tm-dash-grid">
        <!-- Stats + tab switch -->
        <div class="tm-card tp-std-side tm-reveal">
          <div class="tp-std-stat">
            <span class="tm-icon-tile"><FontAwesomeIcon icon="fa-solid fa-layer-group" /></span>
            <div>
              <div v-if="showSkillNum" class="tp-std-stat__num tm-mono">{{ skills.length }}</div>
              <div class="tp-std-stat__label">Total skills</div>
            </div>
          </div>
          <div class="tp-std-stat">
            <span class="tm-icon-tile"><FontAwesomeIcon icon="fa-solid fa-briefcase" /></span>
            <div>
              <div v-if="showJobNum" class="tp-std-stat__num tm-mono">{{ jobs.length }}</div>
              <div class="tp-std-stat__label">Total jobs</div>
            </div>
          </div>

          <div class="tm-segmented tp-std-tabs">
            <button
              type="button"
              class="tm-segmented__btn"
              :class="{ active: activeTab === 'home' }"
              @click="activeTab = 'home'"
            >Your skills</button>
            <button
              type="button"
              class="tm-segmented__btn"
              :class="{ active: activeTab === 'menu1' }"
              @click="activeTab = 'menu1'"
            >Your jobs</button>
          </div>
        </div>

        <!-- List -->
        <div class="tp-std__list">
          <div v-show="activeTab === 'home'" class="tp-row-head">
            <span>Your Input</span>
            <span>Standard Version</span>
          </div>
          <div v-show="activeTab === 'home'">
            <div v-for="(item,i) in skills" :key="i" class="tp-row">
              <div class="tp-row__input">{{ item.input }}</div>
              <div class="tp-row__field">
                <input
                  type="text"
                  v-model="item.output"
                  class="tp-row__output"
                  @click="item.showDropdown = !item.showDropdown"
                  @blur="handleBlur1(item,i)"
                />
                <button type="button" class="tp-icon-btn tp-icon-btn--danger" aria-label="Delete" @click="deleteSkill(item.skillid)">
                  <FontAwesomeIcon icon="fa-solid fa-trash-can" />
                </button>
                <SuggestionDropdown
                  :items="item.other && item.other !== 'None' ? item.other[0] : []"
                  :visible="item.showDropdown && item.other !== 'None'"
                  @select="(option) => selectOption(option, item)"
                />
              </div>
            </div>
          </div>

          <div v-show="activeTab === 'menu1'" class="tp-row-head">
            <span>Your Input</span>
            <span>Standard Version</span>
          </div>
          <div v-show="activeTab === 'menu1'">
            <div v-for="(item,i) in jobs" :key="i" class="tp-row">
              <div class="tp-row__input">{{ item.input }}</div>
              <div class="tp-row__field">
                <input
                  type="text"
                  v-model="item.output"
                  class="tp-row__output"
                  @click="item.showDropdown = !item.showDropdown"
                  @blur="handleBlur2(item,i)"
                />
                <button type="button" class="tp-icon-btn tp-icon-btn--danger" aria-label="Delete" @click="deleteJob(item.occupid)">
                  <FontAwesomeIcon icon="fa-solid fa-trash-can" />
                </button>
                <SuggestionDropdown
                  :items="item.other ? item.other[0] : []"
                  :visible="item.showDropdown && !!item.other"
                  @select="(option) => selectOption(option, item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { UserInfoApiService } from '@/services/UserInfoApiService';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashCan, faLayerGroup, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { defineComponent, onMounted, ref } from 'vue';
import SuggestionDropdown from '@/components/SuggestionDropdown.vue';

export default defineComponent({
  components:{FontAwesomeIcon, SuggestionDropdown},
  setup() {
    library.add(faTrashCan, faLayerGroup, faBriefcase)
    const skills = ref();
    const showJobNum = ref(false);
    const showSkillNum = ref(false);
    const jobs = ref();
    const activeTab = ref('home')

    onMounted(()=>{
      UserInfoApiService.getSkills(localStorage.getItem('user_id')).then((res)=>{
        skills.value = res.data.user_skills.map((skill) => {
          const display = (skill.final && skill.final !== 'None') ? skill.final
                        : (skill.output && skill.output !== 'None') ? skill.output
                        : skill.input;
          return {
            ...skill,
            output: display,
            showDropdown: false,
            other: (skill.other && skill.other !== "None") ? JSON.parse(skill.other) : null
          };
        });
        showSkillNum.value = true;
      })
      UserInfoApiService.getJobs(localStorage.getItem('user_id')).then((res)=>{
        jobs.value = res.data.user_occups.map((occup) => {
          const display = (occup.final && occup.final !== 'None') ? occup.final
                        : (occup.output && occup.output !== 'None') ? occup.output
                        : occup.input;
          return {
            ...occup,
            output: display,
            showDropdown: false,
            other: (occup.other && occup.other !== "None") ? JSON.parse(occup.other) : null
          };
        });
        showJobNum.value = true
      })
    })

    function selectOption(option,item) {
      item.output = option;
      item.showDropdown = false;
      if (item.skillid) {
        UserInfoApiService.EditSkills([{'_id':item.skillid,'skill':item.output,'skill_flag':0}])
      } else if (item.occupid) {
        UserInfoApiService.EditJobs([{'_id':item.occupid,'occup':item.output}])
      }
    }

    // بستن دراپ‌دان هنگام خروج فوکوس
    function handleBlur1(item,i) {
      setTimeout(() => {
        UserInfoApiService.EditSkills([{'_id':item.skillid,'skill':item.output,'skill_flag':0}])
        item.showDropdown = false;
        skills.value[i] = item
      }, 200);
    }
    function handleBlur2(item,i) {
      setTimeout(() => {
        UserInfoApiService.EditJobs([{'_id':item.occupid,'occup':item.output}])
        item.showDropdown = false;
        jobs.value[i] = item
      }, 200);
    }

    function deleteJob(id){
      UserInfoApiService.DeleteOccup(id).then((res)=>{
        if (res.status==200) {
          jobs.value = jobs.value.filter(item => item.occupid !== id);
        }
      })
    }

    function deleteSkill(id){
      UserInfoApiService.DeleteSkill(id).then((res)=>{
        if (res.status==200) {
          skills.value = skills.value.filter(item => item.skillid !== id);
        }
      })
    }


    return {
      skills,
      jobs,
      showJobNum,
      showSkillNum,
      activeTab,
      deleteJob,
      deleteSkill,
      selectOption,
      handleBlur1,
      handleBlur2,
    };
  },
});
</script>

<style scoped>
.tp-std-side {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 22px;
}

.tp-std-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 4px;
}

.tp-std-stat__num {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--tm-ink);
  line-height: 1.2;
}

.tp-std-stat__label {
  font-size: 0.76rem;
  color: var(--tm-ink-muted);
}

.tp-std-tabs {
  display: flex;
  width: 100%;
  margin-top: 14px;
}

.tp-std-tabs .tm-segmented__btn { flex: 1; }

.tp-std__list {
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: var(--tm-radius-md);
  padding: 8px 20px;
  box-shadow: var(--tm-shadow-sm);
}

.tp-row-head {
  display: flex;
  justify-content: space-between;
  padding: 12px 4px 6px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--tm-ink-faint);
}

.tp-row {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 14px 4px;
  border-top: 1px solid var(--tm-border);
}

.tp-row__input {
  flex: 0 0 30%;
  color: var(--tm-ink-muted);
  font-size: 0.9rem;
}

.tp-row__field {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tp-row__output {
  flex: 1;
  border: none;
  border-bottom: 1px solid var(--tm-border-strong);
  background: transparent;
  padding: 6px 2px;
  font-size: 0.95rem;
  color: var(--tm-ink);
  outline: none;
  transition: border-color 0.15s ease;
}

.tp-row__output:focus {
  border-bottom-color: var(--tm-accent);
}

.tp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: var(--tm-radius-sm);
  background: transparent;
  color: var(--tm-ink-muted);
  cursor: pointer;
  transition: background 0.15s ease;
  flex-shrink: 0;
}

.tp-icon-btn:hover {
  background: var(--tm-surface-hover);
}

.tp-icon-btn--danger {
  color: var(--tm-danger);
}
</style>
